// Library Imports
import React, { useState, FC } from 'react';

// Local Imports
import TableMainBody from './TableBody';
import TableHeader from './TableHeader';
import TablePagination from './TablePagination';

type CustomTableProps = {
  rows: any[];
  columns: any[];
  selectedIds: Number[];
  setSelectedIds: Function;
  tableColumnExtensions: any;
  dataProviders?: any;
  onRowClick?: Function;
  componentHeader?: Boolean;
  loading?: Boolean;
  isRowsEditable?: Boolean;
  editingIds?: string[] | null;
  setEditingIds?: Function;
};

const CustomTable: FC<CustomTableProps> = ({
  rows,
  columns,
  selectedIds,
  setSelectedIds,
  tableColumnExtensions,
  dataProviders,
  onRowClick,
  componentHeader,
  loading,
  isRowsEditable,
  editingIds,
  setEditingIds
}) => {
  // STATEs
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const rowsToShow = rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];

  return (
    <React.Fragment>
      <div
        className={`relative flex flex-col text-black overflow-auto border-1 border-gray-200  ${
          componentHeader ? 'h-[calc(100vh-184px)]' : ' min-h-max'
        }`}
      >
        <table style={{ minWidth: 650 }} aria-label='a dense table'>
          <TableHeader
            rows={rows}
            columns={columns}
            tableColumnExtensions={tableColumnExtensions}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
          {/* TABLE MAIN BODY ROWS */}
          <TableMainBody
            rows={rowsToShow}
            // rows={rows}
            columns={columns}
            tableColumnExtensions={tableColumnExtensions}
            dataProviders={dataProviders}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            onRowClick={onRowClick}
            loading={loading}
            isRowsEditable={isRowsEditable}
            editingIds={editingIds}
            setEditingIds={setEditingIds}
          />
        </table>
        {!loading
          ? rowsToShow?.length === 0 && (
              <div className=' flex flex-col items-center h-96 justify-center'>
                <p className='mt-2 text-[#13343B] whitespace-nowrap text-sm'>No data found.</p>
              </div>
            )
          : null}
      </div>

      {/* Pagination */}
      {rowsToShow?.length > 0 ? (
        <TablePagination
          rows={rows}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
        />
      ) : (
        <div className='border-t border-gray-200' />
      )}
    </React.Fragment>
  );
};
export default CustomTable;
